(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medorra-category-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('medorra-category-search')) {
    customElements.define('medorra-category-search', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = this.querySelector('form');
        const category = this.querySelector('[data-category]');
        const input = this.querySelector('input[name="q"]');
        if (!form || !category || !input) return;
        const syncSelection = () => {
          const current = new URL(window.location.href);
          if (current.pathname !== new URL(form.action).pathname) return;
          const activeTypes = current.searchParams.getAll('filter.p.product_type');
          let option = Array.from(category.options).find((item) => {
            if (item.dataset.custom) return false;
            const types = JSON.parse(item.dataset.types || '[]');
            return activeTypes.length === 0 ? types.length === 0 :
              activeTypes.every((type) => types.includes(type));
          });
          if (!option && activeTypes.length) {
            option = category.querySelector('[data-custom]');
            if (!option) {
              option = new Option(category.dataset.customLabel, '__custom');
              option.dataset.custom = 'true';
              option.disabled = true;
              category.append(option);
            }
            option.dataset.types = JSON.stringify(activeTypes);
          }
          category.value = option?.value || '';
          const clear = this.querySelector('[data-clear]');
          if (clear) clear.href = option?.dataset.url || category.options[0].dataset.url;
          const allSearch = this.querySelector('[data-all-search]');
          if (allSearch) allSearch.hidden = activeTypes.length === 0;
        };
        syncSelection();
        document.addEventListener('search:update', syncSelection, { signal: this.controller.signal });
        window.addEventListener('popstate', syncSelection, { signal: this.controller.signal });
        window.addEventListener('pageshow', syncSelection, { signal: this.controller.signal });
        const navigate = () => {
          const selected = category.selectedOptions[0];
          const term = input.value.trim();
          if (!term) {
            window.location.assign(selected.dataset.url);
            return;
          }
          const url = new URL(form.action);
          url.searchParams.set('type', 'product');
          url.searchParams.set('q', term);
          for (const productType of JSON.parse(selected.dataset.types || '[]')) {
            url.searchParams.append('filter.p.product_type', productType);
          }
          window.location.assign(url.href);
        };
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          navigate();
        }, { signal: this.controller.signal });
        category.addEventListener('change', navigate, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
